<template>
  <b-link class="btn btn-sm btn-icon" @click="$emit('click', $event)">
    <i class="fas fa-minus" />
  </b-link>
</template>

<script>
export default {};
</script>
